module.exports = __webpack_public_path__ + "static/img/sgsw2.12e1905.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sgsw2.svg
// module id = TeJN
// module chunks = 1